import { TICK } from "Models/constants";
import { setGlobal } from "Redux/actions";
import { getCurrentTick, getPaused } from "Redux/selectors";
import { getPace } from "Redux/selectors/global";
import store, { dispatch } from "Redux/store";
import { interval, Subject, Subscription } from "rxjs";
import { filter, tap } from "rxjs/operators";

let intervalSub$: Subscription;
export const mainTimeline$ = new Subject<number>();

export const stopTimeline = () => {
    if (intervalSub$) intervalSub$.unsubscribe();
};

export const startTimeline = () => {
    if (intervalSub$) intervalSub$.unsubscribe();

    intervalSub$ = interval(TICK)
        .pipe(
            filter((_) => !isPaused()),
            filter((v) => v % getPace(store.getState()) === 0),
            tap(() => increaseCurrentTick())
        )
        .subscribe((v) => {
            mainTimeline$.next(v);
        });
};

export const pauseTimeline = () => dispatch(setGlobal({ paused: true }));
export const resumeTimeline = () => dispatch(setGlobal({ paused: false }));

export const resetTick = () => dispatch(setGlobal({ currentTick: 0 }));
export const increaseCurrentTick = () => {
    const tick = getCurrentTick(store.getState());
    dispatch(setGlobal({ currentTick: tick + 1, tickTime: Date.now() }));
};

const isPaused = () => getPaused(store.getState());
